import { Injectable } from '@angular/core';
import { BrowserXhr } from '@angular/http';
import { ProgressEventService } from './progress-event.service';

@Injectable()
export class CustomBrowserXhrService  extends BrowserXhr{

    constructor(private service:ProgressEventService) {
        super();
    }
    build(): any {
        console.log(4567890)
      let xhr = super.build();
//      xhr.onprogress = (event) => {
////        this.service.downloadProgress.next(event);
//      };
//
//      xhr.upload.onprogress = (event) => {
////        this.service.uploadProgress.next(event);
//      };
      return <any>(xhr);
    }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/common/http/custom-browser-xhr.service.ts